<template>
  <div>
    <!--
    <button class="close-btn" @click="hideItemDetails"><b-icon icon="X" scale="2.0"></b-icon></button>
    -->
    
    <div class="loader d-flex justify-content-center" v-if="item == null">
      <b-spinner :label="$t('common_phrases.loading')"></b-spinner>
    </div>
    <div class="detail-view" v-if="item != null">
       <h4>
        {{name}}
        <a href="#" class="action-link" @click="editStop" v-b-tooltip :title="$t('map.buttons.edit_stop')"><b-icon icon="gear-fill" scale="1.0"></b-icon></a>
      </h4>
      <!-- <h4><b-icon icon="flag" scale="1.0"></b-icon>{{name}}</h4>-->
      <!--
      <b-row v-if="this.spatialData == null" class="no_spatial_info">
        <b-col><b-icon icon="exclamation-circle-fill" variant="warning"></b-icon>
        {{$t('map.warnings.location_lack')}}</b-col>
      </b-row>
      -->
      <div class="attr-table">
        <b-row><b-col>{{ $t('map.label.id') }}</b-col><b-col>{{ item.tunnus }}</b-col></b-row>
        <b-row v-if="item.sms"><b-col>{{ $t('map.label.number') }}</b-col><b-col>{{ item.sms }}</b-col></b-row>
        <b-row v-if="item.laituri"><b-col>{{ $t('map.label.plat') }}</b-col><b-col>{{ item.laituri }}</b-col></b-row>
        <b-row><b-col>{{ $t('map.label.name') }}</b-col><b-col>{{ name }}</b-col></b-row>
        <b-row><b-col>{{ $t('map.label.linetype') }}</b-col><b-col>{{ getLineType(item) }}</b-col></b-row>
        <b-row><b-col>{{ $t('map.label.lat') }}</b-col><b-col>{{ getCoordinate(item.location.latitude) }}</b-col></b-row>
        <b-row><b-col>{{ $t('map.label.lon') }}</b-col><b-col>{{ getCoordinate(item.location.longitude) }}</b-col></b-row>

        <b-row v-for="orgStopFeature in organisationStopFeatures" :key="orgStopFeature.id">
          <b-col>{{ $t(orgStopFeature.descriptionId) }}</b-col>
          
          <b-col v-if="orgStopFeature.type === 'BOOLEAN'">
            <b-icon v-if='getBoolean(orgStopFeature.name)' icon="check-square" variant="success"></b-icon>
            <b-icon v-else icon="square" ></b-icon>
          </b-col>

        </b-row>

      </div>

      <!--
      <hr>
      <div class="buttons">
        <p-button size="sm" outline @click="addTextAnnouncement" v-b-tooltip :title="$t('map.buttons.add_text_announcement')"><b-icon icon="card-text" scale="1.0"></b-icon></p-button>
        <p-button size="sm" outline @click="addImageAnnouncement" v-b-tooltip :title="$t('map.buttons.add_image_announcement')"><b-icon icon="card-image" scale="1.0"></b-icon></p-button>
      </div>
      -->
      
      <!--
      <div class="spacer"></div>
-->
    <!--  <hr> -->
     <StopDeparturesList :stopTunnus="item.tunnus" :expandable="false"></StopDeparturesList> 
      

      <!--
      <div class="spacer"></div>
      
      
      <b-container fluid="sm" >
      <b-row>
        <b-col><p-button type="primary" @click="addTextAnnouncement" outline size="sm" v-b-tooltip :title="$t('map.buttons.add_text_announcement')"><b-icon icon="card-text" scale="1.0"></b-icon><span></span></p-button></b-col>
        <b-col><p-button type="primary" @click="addImageAnnouncement" outline size="sm" v-b-tooltip :title="$t('map.buttons.add_image_announcement')"><b-icon icon="card-image" scale="1.0"></b-icon><span></span></p-button></b-col>
        <b-col><p-button size="sm" outline @click="editStop" v-b-tooltip :title="$t('map.buttons.edit_stop')"><b-icon icon="gear-fill" scale="1.0"></b-icon></p-button></b-col>
      </b-row>
      </b-container>
      -->

    </div>
  </div>
</template>

<script>
import mapstore from '@/store/map/mapstore';
import StopDeparturesList from '@/components/Map/StopDeparturesList'
import timetable from '@/store/timetable/timetable'

export default {
  name: 'MapStopDetails',
  components: {
    StopDeparturesList
  },
  data: function() {
    return {
      item: null,
      spatialData: null
    }
  },
  props: {
   // msg: String
    itemId: {type: String, default: null}
  },
  beforeCreate: function() {
    if (!this.$store.state.mapstore) {
      this.$store.registerModule("mapstore" , mapstore);
    }
    if (!this.$store.state.timetable) {
      this.$store.registerModule("timetable" , timetable);
    }

  },
  watch: {
  },
  mounted() {
      this.$store.dispatch('mapstore/getStopsForTable').then(
      (data) => {
        var found = null;
        var $vm = this;
        found = data.find((i)=>{
          try{
            return i.tunnus == $vm.$props.itemId
          } catch(err) {/*typerä kääntäjä*/}
        });
        this.item = found;
        this.spatialData = found.spatialData;
      },
      ()=>{ 
      /* error hanskaus */
      });
  },
  computed: {
    name: function() {
      try {
        return this.item.nimi;
      } catch(err) {
        return "";
      }
    },
    organisationStopFeatures() {
      return this.$store.state.timetable.organisationStopFeatures.list;
    }
  },
  methods: {
    hideItemDetails: function() {
      this.$emit('hideItemDetails');
    },
    editStop: function() {
      this.$router.push({ path: '/timetables/stops', query: { id: this.item.tunnus }});
    },
    addTextAnnouncement: function() {
      this.$router.push({ path: '/content/info', query: { targetStop: this.item.tunnus,command:"new" }});
    },
    addImageAnnouncement: function() {
      this.$router.push({ path: '/content/images', query: { targetStop: this.item.tunnus,command:"new" }});
    },
    getLineType(item){
      var type = (item.stopFeatures && item.stopFeatures.LINE_TYPE) ? item.stopFeatures.LINE_TYPE : "x";
      return this.$t('map.stop_type.' + type);
    },
    getCoordinate(coord){
      var val = "-";
      if(coord) val = ("" + coord).substr(0, 10)
      return val
    },
    getBoolean(name){
      var value = this.item.stopFeatures[name];
      return value && value == 'true';
    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import 'mapDetail.scss';
</style>
